import { Avatar, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { Card, CardContent, CardHeader, Typography } from '../..';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        '& + &': {
            marginTop: theme.spacing(1),
        },
    },
    cardContent: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.secondary,
        padding: theme.spacing(2),
        '&:last-child': {
            padding: theme.spacing(2),
        },
    },
    panelHeader: {
        marginTop: '0 !important',
        paddingRight: theme.spacing(1),
    },
    highlight: {
        borderLeftColor: `${theme.palette.secondary.main} !important`,
        borderLeftWidth: `3px !important`,
    },
    secondaryIconStyles: {
        fontSize: 24,
        color: theme.palette.secondary.main,
        marginRight: theme.spacing(-3.5),
    },
}));
const getAvatarComponent = (logo) => {
    if (logo && logo.toString().includes('http')) {
        return React.createElement(Avatar, { src: logo.toString() });
    }
    return logo;
};
export const SingleInfoCard = ({ notes, highlight, rightTitle, rightSubtitle, link, leftTitle, leftSubtitle, logo, action, openInNewTab, }) => {
    const classes = useStyles({});
    const avatar = getAvatarComponent(logo);
    return (React.createElement(Card, { className: highlight ? `${classes.highlight} ${classes.root}` : classes.root },
        React.createElement(CardHeader, { title: leftTitle, subheader: leftSubtitle, rightTitle: rightTitle, rightSubheader: rightSubtitle, link: link, avatar: avatar, action: action, openInNewTab: openInNewTab }),
        notes && (React.createElement(CardContent, { surface: "main", classes: { root: classes.cardContent } },
            React.createElement(Typography, { display: "inline", variant: "caption" }, notes)))));
};
//# sourceMappingURL=SingleInfoCard.js.map